import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../Component/axiosInstance";

const addjobgraphland = createAsyncThunk(
  "jobgraphland",
  async ({ newDataPoint , projectiondataID , apitotarget }, {rejectWithValue}) => {
    console.log(`this is newDataPoint ${newDataPoint} , ${JSON.stringify(projectiondataID)} , ${apitotarget}`)
     if (apitotarget === 'jobimpact') {
        try {
            var job_impact = [newDataPoint]
            const response = await axiosInstance.post('/project/storejob', { job_impact } , 
              {
                  headers:{
                      'x-project-id' :projectiondataID.projectid
                  }
              }
            );
            return response.data;
          } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Some Error Occurred");
          }
     }else if(apitotarget ===  'population'){
        try {
            var population_trend = [newDataPoint]
            const response = await axiosInstance.post('/project/storePopulation', { population_trend } , 
              {
                  headers:{
                      'x-project-id' :projectiondataID.projectid
                  }
              }
            );
            return response.data;
          } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Some Error Occurred");
          }
     }else{
        var land_price_predection = [newDataPoint]
        try {
            const response = await axiosInstance.post('/project/storeLandPrice', { land_price_predection } , 
              {
                  headers:{
                      'x-project-id' :projectiondataID.projectid
                  }
              }
            );
            return response.data;
          } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Some Error Occurred");
          }
     }
  }
);

const addjobgraphlandSlice = createSlice({
  name: "addjobgraphland",
  initialState: {
    loading: false,
    error: null,
    data: null,
    isSuccess: false,
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addjobgraphland.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.data = null;
        state.isSuccess = false;
        state.isError = false;
      })
      .addCase(addjobgraphland.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.isSuccess = true;
        state.isError = false;
      })
      .addCase(addjobgraphland.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
        state.data = null;
        state.isError = true;
        state.isSuccess = false;
      });
  }
});

export { addjobgraphland };
export default addjobgraphlandSlice.reducer;
